import HttpRequest from '@/lib/request'
//export const backendServer = "https://api.weiquanai.com"
export const backendServer = "https://api.weiquanai.com"
export const jwtServerInstance = new HttpRequest(backendServer)
